const searchResults = document.getElementById('search-field');

if (searchResults) {
  new GhostFinder({
    input: '#search-field',
    showResult: '#search-results',
    contentApiKey: 'f35930d9d158987643ea9755b5',
    homeUrl: 'https://2muchcoffee.com/blog',
    resultTemplate: `
    <p class='search-results-count'>Search match(es): ##resultCount</p>
    ##results
  `,
    singleResultTemplate: `
    <div class="search-result">
      <img class="search-result-image" src="##feature_image" alt="##title"/>
      <div class="search-result-text">
        <h2>
          <a class='search-result-title' href="##url">##title</a>
        </h2>
        <p class='search-result-date'>##published_at</p>
      </div>
    </div>
  `,
  });

  searchResults.addEventListener('input', debounce((event) => {
    try {
      sendAnalyticsEvent('Search', {
        // Google specific param
        event_category: 'Blog Posts Search Bar',
        search_term: event.target.value,
        // Facebook pixel specific param
        content_category: 'Blog Posts Search Bar',
        search_string: event.target.value,
      });
    } catch (e) {
      console.warn('Analytics Error: ', e);
    }
  }, 500));
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
